import { createFileRoute } from '@tanstack/react-router'
import { TrackerDetailView } from '@/features/tracker/TrackerDetailView'
import { useViewAsId } from '@/lib/viewAs'

function TrackerDetail() {
  const { id } = Route.useParams()
  return <TrackerDetailView ticketId={id} asUser={useViewAsId()} />
}

export const Route = createFileRoute('/tracker/$id')({ component: TrackerDetail })
